import httpManager from "@/app/shared/utils/httpManager";

/**
 *
 * @param {Object} nodeId
 * @returns {Promise<Object>} Node details
 */

export async function deleteVarInNode(varId: number) {
  const url = `/chatbots/variables/${varId}`;
  const response = await httpManager.delete(url);
  return response.data;
}
